
    var riot = require('riot')
    //src: starling/src/tags/waypoint-selector.html
riot.tag2('waypoint-selector',
  '<div ref="main" id="waypoint-selector" class="waypoint-selector waypoint-selector--hidden" data-x="-75" data-y="-75" style="width: 150px; height: 150px;" ondblclick="{this.handleDoubleClick}"> <div class="waypoint-corner waypoint-corner--top waypoint-corner--left"></div> <div class="waypoint-corner waypoint-corner--top waypoint-corner--right"></div> <div class="waypoint-corner waypoint-corner--bottom waypoint-corner--left"></div> <div class="waypoint-corner waypoint-corner--bottom waypoint-corner--right"></div> <div ref="tip" class="waypoint-selector_tip"> <p class="waypoint-selector_tip_message">Position and resize the box to include the content you want to present.</p> <button onclick="{closeTip}" class="waypoint-selector_tip_button">Got it!</button> </div> <div class="waypoint-selector_buttons"> <button ref="saveButton" data-tip="select a node to add to a slide" class="waypoint-selector_button" onclick="{saveWaypoint}"> <i class="material-icons">check</i> </button> <button class="waypoint-selector_button" onclick="{cancel}"> <i class="material-icons">close</i> </button> </div> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _constants = require('lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = this.opts,
    canvas = _opts.canvas,
    store = _opts.store;

this.width = 150;
this.height = 150;
this.x = 0;
this.y = 0;
this.pendingDragDX = 0;
this.pendingDragDY = 0;

this.on('mount', function () {
  _waypointsUi2.default.setSelector(_this);
  _this.makeInteractable();
  _this.resetSize();
  _this.refs.main.addEventListener('keyup', _this.handleKeyUp);
});

this.makeInteractable = function () {
  (0, _interactjs2.default)(_this.refs.main).styleCursor(false).draggable({
    onstart: _this.recordOriginalPosition,
    onmove: _this.onMove,
    onend: _this.onResizeMoveEnd
  }).resizable({
    edges: {
      top: '.waypoint-corner--top',
      left: '.waypoint-corner--left',
      bottom: '.waypoint-corner--bottom',
      right: '.waypoint-corner--right'
    },
    restrictSize: {
      min: {
        height: 150,
        width: 150
      }
    },
    onstart: _this.recordOriginalPosition,
    onmove: _this.onResize,
    onend: _this.onResizeMoveEnd
  });
};

this.onMove = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy;

  _this.applyMove({ dx: dx, dy: dy });
  _this.closeTip();

  _this.setPendingDragDY(_this.pendingDragDY + dy);
  _this.setPendingDragDX(_this.pendingDragDX + dx);

  if (_this.pendingDragDX > 2) {
    _this.setDragDirectionX('right');
    _this.setPendingDragDX(0);
  } else if (_this.pendingDragDX < -2) {
    _this.setDragDirectionX('left');
    _this.setPendingDragDX(0);
  }
  if (_this.pendingDragDY > 2) {
    _this.setDragDirectionY('down');
    _this.setPendingDragDY(0);
  } else if (_this.pendingDragDY < -2) {
    _this.setDragDirectionY('up');
    _this.setPendingDragDY(0);
  }

  _this.maybePan();
};

this.applyMove = function (_ref2) {
  var dx = _ref2.dx,
      dy = _ref2.dy;
  var main = _this.refs.main;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var x = (parseFloat(main.getAttribute('data-x')) + dx / scale).toFixed(2);
  var y = (parseFloat(main.getAttribute('data-y')) + dy / scale).toFixed(2);

  main.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

  main.setAttribute('data-x', x);
  main.setAttribute('data-y', y);
};

this.onResize = function (_ref3) {
  var rect = _ref3.rect,
      deltaRect = _ref3.deltaRect;
  var main = _this.refs.main;
  var width = rect.width,
      height = rect.height;
  var dx = deltaRect.left,
      dy = deltaRect.top;

  var _canvas$getMatrix2 = canvas.getMatrix(),
      scale = _canvas$getMatrix2.scale;

  _this.width = width / scale;
  _this.height = height / scale;

  Object.assign(main.style, {
    width: _this.width.toFixed(2) + 'px',
    height: _this.height.toFixed(2) + 'px'
  });

  _this.onMove({ dx: dx, dy: dy });
};

this.onResizeMoveEnd = function () {
  var main = _this.refs.main;

  var nodes = _this.getContainingNodes();
  if (!_this.sizeIsReset && !nodes.length) {
    var _originalPosition = _this.originalPosition,
        x = _originalPosition.x,
        y = _originalPosition.y,
        width = _originalPosition.width,
        height = _originalPosition.height;

    main.style.transition = 'transform 0.15s ease-out';
    setTimeout(function () {
      main.style.transition = 'none';
    }, 200);
    Object.assign(main.style, {
      width: width.toFixed(2) + 'px',
      height: height.toFixed(2) + 'px',
      transform: 'translate(' + x + 'px, ' + y + 'px)'
    });
    main.setAttribute('data-x', x);
    main.setAttribute('data-y', y);
  } else if (nodes.length) {
    _this.snapToNodes({ nodes: nodes });
  }
  _this.isResizeMoving = false;
};

this.snapToNodes = function (_ref4) {
  var nodes = _ref4.nodes;
  var main = _this.refs.main;

  var _canvas$getMatrix3 = canvas.getMatrix(),
      scale = _canvas$getMatrix3.scale,
      tx = _canvas$getMatrix3.tx,
      ty = _canvas$getMatrix3.ty;

  var extentsList = canvas.getContentExtents({ nodes: nodes });

  var extents = {
    et: extentsList[0],
    el: extentsList[1],
    eb: extentsList[2],
    er: extentsList[3]
  };

  var margin = 20;

  var y = extents.et - margin;
  var x = extents.el - margin;
  var height = extents.eb - extents.et + margin + 8 * 1 / scale;
  var width = extents.er - extents.el + margin + 8 * 1 / scale;

  main.setAttribute('data-x', 0);
  main.setAttribute('data-y', 0);

  Object.assign(main.style, {
    width: width.toFixed(2) + 'px',
    height: height.toFixed(2) + 'px',
    left: x + 'px',
    top: y + 'px',
    transform: 'translate(0,0)'
  });

  _this.height = height;
  _this.width = width;
  _this.x = 0;
  _this.y = 0;
  _this.sizeIsReset = false;
  _this.enableSaveButton();
};

this.closeTip = function () {
  var tip = _this.refs.tip;

  tip.classList.add('waypoint-selector_tip--hidden');
};

this.show = function () {
  var main = _this.refs.main;

  main.classList.remove('waypoint-selector--hidden');
  canvas.disablePanZoom();
  document.addEventListener('keyup', _this.handleKeyUp);
  if (_waypointsUi2.default.isEditing) {
    var waypoint = _waypointsUi2.default.getWaypoint({ id: _waypointsUi2.default.isEditing });
    var nodeIds = waypoint.getNodeIds();
    var nodes = nodeIds.map(function (nId) {
      return store.getNode(nId);
    });
    if (nodes.length) {
      _this.snapToNodes({ nodes: nodes });
    }
  } else {
    _this.resetSize();
  }
};

this.hide = function () {
  var main = _this.refs.main;

  main.classList.add('waypoint-selector--hidden');
  canvas.enablePanZoom();
  document.removeEventListener('keyup', _this.handleKeyUp);
};

this.getContainingNodes = function () {
  var main = _this.refs.main;
  var getNodeTag = canvas.getNodeTag;

  var _canvas$getMatrix4 = canvas.getMatrix(),
      scale = _canvas$getMatrix4.scale,
      tx = _canvas$getMatrix4.tx,
      ty = _canvas$getMatrix4.ty;

  var _main$getBoundingClie = main.getBoundingClientRect(),
      x = _main$getBoundingClie.x,
      y = _main$getBoundingClie.y,
      width = _main$getBoundingClie.width,
      height = _main$getBoundingClie.height;

  var left = (x - tx) / scale;
  var top = (y - ty) / scale;
  var right = left + parseFloat(width / scale);
  var bottom = top + parseFloat(height / scale);

  var positions = {};

  var nodes = store.filterNodes(function (_ref5) {
    var id = _ref5.id;
    var _getNodeTag$absoluteP = getNodeTag({ id: id }).absolutePosition,
        x = _getNodeTag$absoluteP.x,
        y = _getNodeTag$absoluteP.y;
    // Store node position for sorting.

    positions[id] = { x: x, y: y };
    // TODO: Should check if the entire card is inside selection,
    //       not just the top left corner.
    return x > left && x < right && y > top && y < bottom;
  }).sort(function (a, b) {
    return positions[a.id].x - positions[b.id].x;
  });

  return nodes;
};

this.saveWaypoint = function () {
  var nodes = _this.getContainingNodes();
  if (!nodes.length || !_this.saveButtonIsEnabled) return;

  if (_waypointsUi2.default.isAdding) {
    _waypointsUi2.default.addWaypoint({
      nodeIds: nodes.map(function (n) {
        return n.id;
      }),
      title: nodes[0].title
    });
    _waypointsUi2.default.stopAdding();
  } else if (_waypointsUi2.default.isEditing) {
    _waypointsUi2.default.editWaypoint({
      id: _waypointsUi2.default.isEditing,
      nodeIds: nodes.map(function (n) {
        return n.id;
      })
    });
    _waypointsUi2.default.stopEditing();
  }
};

this.cancel = function () {
  _this.resetSize();
  _waypointsUi2.default.stopAdding();
  _waypointsUi2.default.stopEditing();
};

this.handleDoubleClick = function (e) {
  canvas.createNodeOnDblClick(e);
  _this.onResizeMoveEnd();
};

this.recordOriginalPosition = function () {
  _this.setPendingDragDY(0);
  _this.setPendingDragDX(0);
  _this.isResizeMoving = true;
  _this.originalPosition = {
    x: _this.x,
    y: _this.y,
    height: _this.height,
    width: _this.width
  };
};

this.handleKeyUp = function (e) {
  var ESCAPE = _constants.KEY_CODES.ESCAPE,
      ENTER = _constants.KEY_CODES.ENTER;

  if (e.keyCode === ESCAPE) {
    _this.cancel();
  } else if (e.keyCode === ENTER) {
    _this.saveWaypoint();
  }
};

this.resetSize = function () {
  var _canvas$getMatrix5 = canvas.getMatrix(),
      scale = _canvas$getMatrix5.scale,
      tx = _canvas$getMatrix5.tx,
      ty = _canvas$getMatrix5.ty;

  var main = _this.refs.main;

  Object.assign(main.style, {
    width: '150px',
    height: '150px',
    left: (window.innerWidth / 2 - tx - 75) / scale + 'px',
    top: (window.innerHeight / 2 - ty - 75) / scale + 'px'
  });
  _this.sizeIsReset = true;
  _this.disableSaveButton();
};

this.enableSaveButton = function () {
  _this.refs.saveButton.classList.remove('disabled');
  _this.refs.saveButton.removeAttribute('data-tip');
  _this.saveButtonIsEnabled = true;
};

this.disableSaveButton = function () {
  _this.refs.saveButton.classList.add('disabled');
  _this.refs.saveButton.setAttribute('data-tip', 'select a node to add to a waypoint');
  _this.saveButtonIsEnabled = false;
};

var _calculateMove = function _calculateMove(rect) {
  var _canvas$getMatrix6 = canvas.getMatrix(),
      scale = _canvas$getMatrix6.scale,
      tx = _canvas$getMatrix6.tx,
      ty = _canvas$getMatrix6.ty;

  var maxMove = .1;
  var bumper = 20;
  var move = {
    el: {
      x: 0,
      y: 0
    },
    pan: {
      x: 0,
      y: 0
    },
    dirX: '',
    dirY: ''
  };

  if (rect.x <= bumper && _this.dragDirectionX == 'left') {
    move.el.x = maxMove * -1;
    move.pan.x = maxMove;
    move.dirX = 'left';
  }
  if (rect.right >= window.innerWidth - bumper && _this.dragDirectionX == 'right') {
    move.el.x = maxMove;
    move.pan.x = maxMove * -1;
    move.dirX = 'right';
  }
  if (rect.y <= bumper && _this.dragDirectionY == 'up') {
    move.el.y = maxMove * -1;
    move.pan.y = maxMove;
    move.dirY = 'up';
  }
  if (rect.bottom >= window.innerHeight - bumper && _this.dragDirectionY == 'down') {
    move.el.y = maxMove;
    move.pan.y = maxMove * -1;
    move.dirY = 'down';
  }

  return move;
};

this.maybePan = function () {
  if (!_this.isResizeMoving) return;

  var rect = _this.refs.main.getBoundingClientRect();
  var move = _calculateMove(rect);

  if (move.el.x == 0 && move.el.y == 0) {
    window.requestAnimationFrame(_this.maybePan.bind(_this));
    return;
  }

  $('#canvas').panzoom("pan", move.pan.x, move.pan.y, { relative: true });
  _this.applyMove({ dx: move.el.x, dy: move.el.y });
  window.requestAnimationFrame(_this.maybePan.bind(_this));
};

this.setPendingDragDX = function (dx) {
  _this.pendingDragDX = dx;
};

this.setPendingDragDY = function (dy) {
  _this.pendingDragDY = dy;
};

this.setDragDirectionY = function (direction) {
  _this.dragDirectionY = direction;
};

this.setDragDirectionX = function (direction) {
  _this.dragDirectionX = direction;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('waypoint-selector')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/waypoint-selector.html
// module id = 671
// module chunks = 0